import StepProcess from './step-process';

export default {
  tag: 'stepprocess',
  format: `<StepProcess />`,
  sourcePipeline: (source: string) => source,
  componentFn: ({ node, ...props }: any) => {
    return <StepProcess {...props} />;
  },
};
